import {txt, type Texto} from '../i18n/idioma';

// Notas de ayuda de las pestañas de Exportaciones que no son la tabla
// principal (Daniel, 14/10/2026): qué es cada campo y cómo se llena.

// Exportaciones → Contenedores: lo cargado del Seguimiento Concentrados.
export const AYUDA_CONTENEDORES = {
  buscar: txt(
    'Escribe parte del código de la exportación o del número del contenedor y pulsa Enter.',
    'Type part of the export code or the container number and press Enter.',
  ),
  anio: txt(
    'Año en que zarpó el contenedor, según su fecha de zarpe. Puedes elegir varios.',
    'Year the container departed, by its departure date. You can pick several.',
  ),
  soloParaRevisar: txt(
    'Solo los contenedores con alguna fila del Seguimiento Concentrados que entró marcada para revisar: un peso escrito con texto, una cantidad de Big Bags negativa, una fecha en la columna del comprador o un número de contenedor que no es válido.',
    'Only containers with a row of the Seguimiento Concentrados that came in flagged for review: a weight written as text, a negative number of Big Bags, a date in the buyer column or an invalid container number.',
  ),
  exportacion: txt(
    'Código de la exportación del contenedor. En el Seguimiento Concentrados: SHIP N. Ábrela para ver el detalle por proveedor y el recorrido completo.',
    'Code of the container’s export. In the Seguimiento Concentrados: SHIP N. Open it to see the detail by supplier and the full journey.',
  ),
  contenedor: txt(
    'Número del contenedor, sin espacios ni guiones. En el Seguimiento Concentrados: CONTAINER N. (en los contenedores manda este archivo). "⚠ revisar" = alguna de sus filas entró marcada para revisar.',
    'Container number, without spaces or dashes. In the Seguimiento Concentrados: CONTAINER N. (this file wins on containers). "⚠ review" = one of its rows came in flagged for review.',
  ),
  tipo: txt(
    'Tipo de contenedor (por ejemplo, 40’ DRY). En el Seguimiento Concentrados: TYPE.',
    'Container type (for example, 40’ DRY). In the Seguimiento Concentrados: TYPE.',
  ),
  bigBags: txt(
    'Big Bags del contenedor: la suma de la columna N. BB de sus filas (una por proveedor) en el Seguimiento Concentrados.',
    'Big Bags in the container: the sum of the N. BB column of its rows (one per supplier) in the Seguimiento Concentrados.',
  ),
  proveedores: txt(
    'Proveedores con carga en el contenedor. En el Seguimiento Concentrados: SUPPLIER.',
    'Suppliers with cargo in the container. In the Seguimiento Concentrados: SUPPLIER.',
  ),
  recogido: txt(
    'Fecha en que se recogió la carga en la planta. En el Seguimiento Concentrados: PICKUP PLANT DATE.',
    'Date the cargo was picked up at the plant. In the Seguimiento Concentrados: PICKUP PLANT DATE.',
  ),
  entradaPuerto: txt(
    'Fecha en que el contenedor entró al puerto. En el Seguimiento Concentrados: PORT ENTRY DATE.',
    'Date the container entered the port. In the Seguimiento Concentrados: PORT ENTRY DATE.',
  ),
  zarpe: txt(
    'Fecha de zarpe. Si la exportación tiene ETD en el seguimiento de la app, manda esa; si no, la columna ETD del Seguimiento Concentrados.',
    'Departure date. If the export has an ETD in the app’s tracking, that one wins; otherwise the ETD column of the Seguimiento Concentrados.',
  ),
  llegadaRefineria: txt(
    'Fecha en que el contenedor llegó a la refinería. Sale de la columna de llegada a la refinería del Seguimiento Concentrados.',
    'Date the container arrived at the refinery. It comes from the refinery arrival column of the Seguimiento Concentrados.',
  ),
  inspeccionPolicia: txt(
    'Tipo de inspección de la Policía (física, documental, escáner…) y su fecha. En el Seguimiento Concentrados: POLICE INSPECTION TYPE y POLICE INSPECTION DATE.',
    'Type of Police inspection (physical, documentary, scanner…) and its date. In the Seguimiento Concentrados: POLICE INSPECTION TYPE and POLICE INSPECTION DATE.',
  ),
  selectividadDian: txt(
    'Tipo de revisión que la DIAN le asignó al contenedor (automática, documental, física…). Sale del GEX FR08, hoja MARITIMO, columna SELECTIVIDAD.',
    'Type of check DIAN assigned to the container (automatic, documentary, physical…). It comes from the GEX FR08, sheet MARITIMO, column SELECTIVIDAD.',
  ),
  sellos: txt(
    'Cantidad de sellos registrados del contenedor, viejos y nuevos. En el Seguimiento Concentrados: OLD SEALS y NEW SEALS.',
    'Number of seals recorded for the container, old and new. In the Seguimiento Concentrados: OLD SEALS and NEW SEALS.',
  ),
  itr: txt(
    'Peso del contenedor cargado, en kilos, medido en el cargue (ITR). En el Seguimiento Concentrados: WEIGHT CONTAINER LOAD ITR KG.',
    'Weight of the loaded container in kilos, measured at loading (ITR). In the Seguimiento Concentrados: WEIGHT CONTAINER LOAD ITR KG.',
  ),
  refineriaKg: txt(
    'Peso del contenedor al llegar a la refinería, en kilos. Sale de la columna de peso del contenedor en la refinería del Seguimiento Concentrados.',
    'Weight of the container on arrival at the refinery, in kilos. It comes from the refinery container weight column of the Seguimiento Concentrados.',
  ),
  diferencia: txt(
    'La calcula la app: peso en la refinería menos peso del cargue (ITR). Negativo = llegó con menos peso.',
    'The app works it out: refinery weight minus loading weight (ITR). Negative = it arrived lighter.',
  ),
  bl: txt(
    'Número del BL (conocimiento de embarque) de la exportación. En el Seguimiento Concentrados: SWB/BL, o BL N. si la primera está vacía.',
    'BL (bill of lading) number of the export. In the Seguimiento Concentrados: SWB/BL, or BL N. if the first one is empty.',
  ),
} satisfies Record<string, Texto>;

// Exportaciones → GEX: trámite de aduana del GEX FR08 (hoja MARITIMO).
const DEL_GEX = (columna: string, es: string, en: string) =>
  txt(`${es} Del GEX FR08 (hoja MARITIMO): ${columna}.`, `${en} From the GEX FR08 (sheet MARITIMO): ${columna}.`);

export const AYUDA_GEX = {
  buscar: txt(
    'Busca por código de exportación, No. EXP, radicado o aprobación de VUCE, No. SAE, booking, número de factura o número de contenedor. Pulsa Enter.',
    'Search by export code, export no., VUCE filing or approval, SAE no., booking, invoice number or container number. Press Enter.',
  ),
  anio: txt(
    'Año de zarpe: el ETD del seguimiento de la app o, si no lo tiene, la fecha de zarpe del GEX. "Sin dato" = sin zarpe.',
    'Departure year: the ETD in the app’s tracking or, if it has none, the GEX departure date. "No data" = no departure.',
  ),
  exportador: txt(
    'Empresa exportadora de la exportación, según el seguimiento de la app.',
    'Exporting company of the export, per the app’s tracking.',
  ),
  selectividad: DEL_GEX(
    'SELECTIVIDAD',
    'Tipo de revisión que la DIAN le asignó al trámite (automática, documental, física, escáner…). Se puede corregir en el detalle de la exportación, sección Aduana.',
    'Type of check DIAN assigned to the filing (automatic, documentary, physical, scanner…). It can be corrected in the export detail, Customs section.',
  ),
  pais: DEL_GEX('PAIS DESTINO', 'País de destino del trámite.', 'Destination country of the filing.'),
  agenciaAduanas: DEL_GEX(
    'AGENCIA DE ADUANAS',
    'Agencia de aduanas que hizo el trámite.',
    'Customs agency that handled the filing.',
  ),
  soloParaRevisar: txt(
    'Solo los trámites que entraron del GEX con algo para revisar: una fecha que no es fecha o una columna con varios valores distintos en la misma exportación. Pasa el cursor por "⚠ revisar" para ver qué.',
    'Only filings that came from the GEX with something to review: a date that is not a date or a column with several different values for the same export. Hover over "⚠ review" to see what.',
  ),
  conDiferencias: txt(
    'Solo las exportaciones donde el GEX dice otro booking u otra fecha de zarpe que la app. Manda la app.',
    'Only exports where the GEX shows a different booking or departure date than the app. The app wins.',
  ),
  exportacion: DEL_GEX(
    'Export',
    'Código de la exportación del trámite; si el GEX no lo trae, se enlaza por el booking o los contenedores. Ábrela para ver o editar su trámite.',
    'Export code of the filing; if the GEX does not have it, it is linked by booking or containers. Open it to view or edit its filing.',
  ),
  estado: txt(
    'Estado de la exportación en el seguimiento de la app (pestaña Exportaciones).',
    'Status of the export in the app’s tracking (Exports tab).',
  ),
  numeroExportacion: DEL_GEX(
    'No. EXP',
    'Número de la exportación ante la aduana. Se puede editar en el detalle de la exportación, sección Aduana.',
    'Export number with customs. It can be edited in the export detail, Customs section.',
  ),
  facturas: txt(
    'Números de las facturas de la exportación: las que ya tenía la app y las del GEX (columna No. FACTURA).',
    'Invoice numbers of the export: those the app already had and those from the GEX (column No. FACTURA).',
  ),
  fechaFactura: DEL_GEX(
    'FECHA DE FACTURA',
    'Fecha de la primera factura de la exportación.',
    'Date of the export’s first invoice.',
  ),
  toneladas: DEL_GEX(
    'TONELADAS MINERAL / PROFORMA',
    'Toneladas de mineral de las facturas del GEX, sumadas.',
    'Tons of ore on the GEX invoices, added up.',
  ),
  valor: txt(
    'Valor total de las facturas de la exportación, sumado por moneda (USD y COP). Del GEX: VALOR TOTAL DE FACTURA; también cuentan las facturas que ya tenía la app.',
    'Total value of the export’s invoices, added up by currency (USD and COP). From the GEX: VALOR TOTAL DE FACTURA; invoices the app already had also count.',
  ),
  vuceGeneracion: DEL_GEX(
    'FECHA DE GENERACIÓN DE VUCE',
    'Fecha en que se generó el trámite en VUCE.',
    'Date the filing was created in VUCE.',
  ),
  vucePago: DEL_GEX('FECHA DE PAGO DE VUCE', 'Fecha en que se pagó el trámite VUCE.', 'Date the VUCE filing was paid.'),
  vuceRadicado: DEL_GEX('No RADICADO VUCE', 'Número de radicado del trámite en VUCE.', 'Filing number in VUCE.'),
  vuceAprobacion: DEL_GEX('No APROBACION VUCE', 'Número de aprobación de VUCE.', 'VUCE approval number.'),
  vuceFechaAprobacion: DEL_GEX(
    'FECHA DE APROBACION VUCE',
    'Fecha en que VUCE aprobó el trámite.',
    'Date VUCE approved the filing.',
  ),
  saeFecha: DEL_GEX(
    'FECHA SAE',
    'Fecha de la solicitud de autorización de embarque (SAE).',
    'Date of the shipment authorization request (SAE).',
  ),
  saeNumero: DEL_GEX('No SAE', 'Número de la SAE.', 'SAE number.'),
  agenciaCarga: DEL_GEX(
    'AGENCIA DE CARGA',
    'Agencia de carga (forwarder) que gestionó la reserva.',
    'Freight agent (forwarder) that handled the booking.',
  ),
  solicitudReserva: DEL_GEX(
    'FECHA DE SOLICITUD RESERVA',
    'Fecha en que se le pidió la reserva al forwarder.',
    'Date the booking was requested from the forwarder.',
  ),
  fechaBooking: DEL_GEX('FECHA DE BOOKING', 'Fecha en que se confirmó el booking.', 'Date the booking was confirmed.'),
  booking: txt(
    'Número de booking de la naviera. Sale de la app (seguimiento o reserva); si la app no lo tiene, el del GEX (NUMERO DE BOOKING) en cursiva. "reserva" = tiene su reserva registrada en Reservas.',
    'Shipping line booking number. It comes from the app (tracking or booking); if the app has none, the GEX one (NUMERO DE BOOKING) in italics. "booking" = it has its booking registered in Bookings.',
  ),
  naviera: txt(
    'Naviera de la exportación según la app; si la app no la tiene, la del GEX (NAVIERA) en cursiva.',
    'Shipping line of the export per the app; if the app has none, the GEX one (NAVIERA) in italics.',
  ),
  motonave: txt(
    'Buque y viaje según la app; si la app no los tiene, los del GEX (MOTONOVA / NUMERO DE VIAJE) en cursiva.',
    'Vessel and voyage per the app; if the app has none, the GEX ones (MOTONOVA / NUMERO DE VIAJE) in italics.',
  ),
  contenedores: txt(
    'Cantidad de contenedores que la app tiene para la exportación. Clic para ver su logística.',
    'Number of containers the app has for the export. Click to see their logistics.',
  ),
  ingresoPuerto: txt(
    'Primera fecha de ingreso a puerto de sus contenedores (Seguimiento Concentrados, PORT ENTRY DATE); si la app no la tiene, la del GEX (FECHA DE INGRESO A PUERTO) en cursiva.',
    'First port entry date of its containers (Seguimiento Concentrados, PORT ENTRY DATE); if the app has none, the GEX one (FECHA DE INGRESO A PUERTO) in italics.',
  ),
  puerto: txt(
    'Puerto de carga según el seguimiento de la app; si la app no lo tiene, el del GEX (PUERTO) en cursiva.',
    'Port of loading per the app’s tracking; if the app has none, the GEX one (PUERTO) in italics.',
  ),
  fechaInspeccion: DEL_GEX('FECHA DE INSPECCIÓN', 'Fecha de la inspección de la DIAN.', 'Date of the DIAN inspection.'),
  zarpe: txt(
    'Zarpe (ETD) del seguimiento de la app; si la app no lo tiene, la fecha del GEX (FECHA DE ZARPE) en cursiva.',
    'Departure (ETD) from the app’s tracking; if the app has none, the GEX date (FECHA DE ZARPE) in italics.',
  ),
  emisionBl: txt(
    'Fecha de emisión del BL según la app (Seguimiento Concentrados o seguimiento); si la app no la tiene, la del GEX (FECHA EMISIÓN BL) en cursiva.',
    'BL issue date per the app (Seguimiento Concentrados or tracking); if the app has none, the GEX one (FECHA EMISIÓN BL) in italics.',
  ),
  llegada: txt(
    'Llegada real o, si todavía no llega, la ETA del seguimiento de la app; si la app no la tiene, la del GEX (LLEGADA A DESTINO) en cursiva.',
    'Actual arrival or, if it has not arrived yet, the ETA from the app’s tracking; if the app has none, the GEX one (LLEGADA A DESTINO) in italics.',
  ),
  cliente: txt(
    'Comprador de la exportación en la app; si la app no lo tiene, el del GEX (CLIENTE) en cursiva.',
    'Buyer of the export in the app; if the app has none, the GEX one (CLIENTE) in italics.',
  ),
} satisfies Record<string, Texto>;

// Exportaciones → Reservas: bookings leídos del PDF de la naviera o escritos a mano.
const DEL_PDF = txt(
  ' Se lee del PDF de la reserva o se escribe a mano.',
  ' It is read from the booking PDF or typed in by hand.',
);
const conPdf = (es: string, en: string) => txt(es + DEL_PDF.es, en + DEL_PDF.en);

export const AYUDA_RESERVAS = {
  buscar: txt(
    'Escribe parte del número de booking o del código de la exportación.',
    'Type part of the booking number or the export code.',
  ),
  estado: txt(
    'Activas = las vigentes. Todas = también las canceladas.',
    'Active = the current ones. All = cancelled ones too.',
  ),
  naviera: conPdf(
    'Naviera de la reserva. La app lee los PDF de Maersk, Hapag-Lloyd y CMA CGM; las demás van como "Otra naviera".',
    'Shipping line of the booking. The app reads the PDFs of Maersk, Hapag-Lloyd and CMA CGM; others go as "Other shipping line".',
  ),
  numero: conPdf('Número de la reserva (booking) que da la naviera.', 'Booking number given by the shipping line.'),
  contenedores: conPdf(
    'Cantidad de contenedores reservados. La app nunca asigna más contenedores que estos.',
    'Number of containers booked. The app never assigns more containers than these.',
  ),
  tipoContenedor: conPdf(
    'Tipo de contenedor reservado (por ejemplo, 40HC).',
    'Type of container booked (for example, 40HC).',
  ),
  etd: conPdf(
    'Salida (ETD): la fecha de salida del primer buque desde un puerto colombiano. Las alertas cuentan los días hasta esta fecha.',
    'Departure (ETD): the departure date of the first vessel from a Colombian port. Alerts count the days to this date.',
  ),
  etaPuerto: conPdf(
    'Llegada estimada (ETA) al puerto de descarga: la del último tramo por mar.',
    'Estimated arrival (ETA) at the port of discharge: that of the last sea leg.',
  ),
  etaFinal: conPdf(
    'Llegada estimada al destino final, cuando después del puerto sigue otro tramo.',
    'Estimated arrival at the final destination, when another leg follows the port.',
  ),
  fechaReserva: conPdf(
    'Fecha en que la naviera generó la reserva (en Maersk, la fecha de impresión del PDF).',
    'Date the shipping line generated the booking (for Maersk, the PDF print date).',
  ),
  cierreDocumentos: conPdf(
    'Último momento para enviar las instrucciones de embarque (SI), en hora de Colombia. La app avisa desde 3 días antes.',
    'Deadline to send the shipping instructions (SI), Colombia time. The app warns from 3 days before.',
  ),
  cierreVgm: conPdf(
    'Último momento para enviar el VGM (peso verificado del contenedor). La app avisa desde 3 días antes.',
    'Deadline to send the VGM (verified gross mass). The app warns from 3 days before.',
  ),
  cierrePuerto: conPdf(
    'Último momento para que el contenedor entre al terminal. La app avisa desde 3 días antes.',
    'Deadline for the container to enter the terminal. The app warns from 3 days before.',
  ),
  diasLibres: txt(
    'Días libres en destino acordados con la naviera. Los PDF de las navieras no los traen: se escriben a mano y pasan a la exportación vinculada.',
    'Free days at destination agreed with the shipping line. The PDFs do not include them: type them in and they go to the linked export.',
  ),
  buque: conPdf('Nombre del buque.', 'Vessel name.'),
  viaje: conPdf('Número del viaje del buque.', 'Vessel voyage number.'),
  buqueViaje: conPdf('Nombre del buque y número del viaje.', 'Vessel name and voyage number.'),
  puertoCarga: conPdf('Puerto donde se cargan los contenedores.', 'Port where the containers are loaded.'),
  puertoDescarga: conPdf(
    'Puerto donde se descargan los contenedores (el último por mar).',
    'Port where the containers are unloaded (the last by sea).',
  ),
  destinoFinal: conPdf('Lugar de entrega final de la carga.', 'Final place of delivery of the cargo.'),
  vincular: txt(
    'Código de la exportación a la que pertenece la reserva. Al vincular, la app revisa si existe (si no, la crea), compara sus datos con los de la reserva (se queda lo que ya tiene y toma lo que falta) y llena los contenedores: con los Big Bags que la exportación ya tiene o, si no tiene, con 28 Big Bags del mismo exportador.',
    'Code of the export the booking belongs to. On linking, the app checks whether it exists (if not, it creates it), compares its data with the booking (it keeps what it has and takes what is missing) and fills the containers: with the Big Bags the export already has or, if it has none, with 28 Big Bags from the same exporter.',
  ),
  minas: txt(
    'De qué minas del exportador se toman los Big Bags para llenar los contenedores. Sin ninguna marcada, de todas.',
    'Which of the exporter’s mines the Big Bags are taken from to fill the containers. With none checked, from all.',
  ),
  exportacion: txt(
    'Exportación a la que está vinculada la reserva. "sin vincular" = todavía no tiene: vincúlala en el detalle de la reserva.',
    'Export the booking is linked to. "not linked" = it has none yet: link it in the booking detail.',
  ),
  completos: txt(
    'La calcula la app: contenedores de la exportación que ya tienen sus 28 Big Bags, contra los contenedores de la reserva. En rojo si falta alguno.',
    'The app works it out: containers of the export that already have their 28 Big Bags, against the booking’s containers. In red if any are missing.',
  ),
  diasSalida: txt(
    'Fecha de salida (ETD) y los días que faltan. Las que zarpan en 3 días o menos van resaltadas.',
    'Departure date (ETD) and the days left. Those departing within 3 days are highlighted.',
  ),
  llegada: txt(
    'Llegada al destino final o, si la reserva no la trae, al puerto de descarga.',
    'Arrival at the final destination or, if the booking does not have it, at the port of discharge.',
  ),
  cambios: txt(
    'Cambios de fecha, contenedores o buque detectados (por un PDF nuevo, la naviera o un cambio a mano) que nadie ha marcado como revisados.',
    'Changes to dates, containers or vessel detected (by a new PDF, the shipping line or a manual change) that nobody has marked as reviewed.',
  ),
  bigBagsAsignados: txt('Big Bags que ya tiene asignados la exportación.', 'Big Bags already assigned to the export.'),
  tramos: txt(
    'Tramos del viaje como los trae el PDF de la reserva: desde dónde, hacia dónde, en qué medio, buque y fechas.',
    'Voyage legs as the booking PDF shows them: from where, to where, by what means, vessel and dates.',
  ),
  tramoMedio: txt(
    'Medio del tramo (buque, camión, tren…), según el PDF.',
    'Mode of the leg (vessel, truck, rail…), per the PDF.',
  ),
  revisionDato: txt(
    'Dato del seguimiento de la exportación que la reserva también trae.',
    'Tracking field of the export that the booking also has.',
  ),
  revisionExportacion: txt(
    'Lo que la exportación tiene hoy en el seguimiento. Clic para dejarlo.',
    'What the export has today in tracking. Click to keep it.',
  ),
  revisionReserva: txt('Lo que trae la reserva. Clic para dejarlo.', 'What the booking has. Click to keep it.'),
  revisionQueda: txt(
    'Lo que quedará en el seguimiento al vincular. Vacío = la exportación conserva lo que tiene.',
    'What will stay in tracking after linking. Empty = the export keeps what it has.',
  ),
  historial: txt(
    'Cada cambio de fecha, contenedores o buque de la reserva: antes y después, de dónde vino (PDF nuevo, página de la naviera o cambio a mano) y quién lo revisó.',
    'Each change to the booking’s dates, containers or vessel: before and after, where it came from (new PDF, shipping line website or manual change) and who reviewed it.',
  ),
} satisfies Record<string, Texto>;

// Exportaciones → Alertas de reservas.
export const AYUDA_ALERTAS = {
  salida: txt(
    'Fecha de salida (ETD) de la reserva y los días que faltan. Los avisos salen desde 20 días antes, otra vez desde 16 y el último desde 3.',
    'Departure date (ETD) of the booking and the days left. Notices start 20 days before, again from 16 and the last one from 3.',
  ),
  completos: txt(
    'La calcula la app: contenedores de la exportación que ya tienen sus 28 Big Bags, contra los contenedores de la reserva.',
    'The app works it out: containers of the export that already have their 28 Big Bags, against the booking’s containers.',
  ),
  disponibles: txt(
    'Big Bags del mismo exportador que están disponibles en bodega (sin exportación), para completar lo que falta.',
    'Big Bags from the same exporter that are available in the warehouse (no export), to fill what is missing.',
  ),
} satisfies Record<string, Texto>;

// Exportaciones → Navieras.
export const AYUDA_NAVIERAS = {
  conexion: txt(
    '"Conectada" = la app consulta a la naviera directamente con su clave. "Con el rastreador" = se actualiza subiendo los PDF y el Excel del rastreador.',
    '"Connected" = the app checks with the shipping line directly using its key. "With the tracker" = it is updated by uploading the tracker’s PDFs and Excel.',
  ),
  enCurso: txt(
    'Exportaciones que no han terminado (según su estado en el seguimiento) y cuya naviera es esta.',
    'Exports not yet finished (by their status in tracking) whose shipping line is this one.',
  ),
  ultimaConsulta: txt(
    'Última vez que la app consultó un booking de esta naviera.',
    'Last time the app checked a booking with this shipping line.',
  ),
  automatica: txt(
    'Hora a la que la app revisa sola cada día los bookings de las navieras conectadas.',
    'Time at which the app checks the bookings of connected shipping lines by itself every day.',
  ),
  ultimaRevision: txt('Última consulta registrada a cualquier naviera.', 'Last check recorded with any shipping line.'),
  porRevisar: txt(
    'Consultas que cambiaron algún dato de una exportación (ETD, ETA, buque o ubicación) y nadie ha marcado como revisadas.',
    'Checks that changed some export data (ETD, ETA, vessel or location) and nobody has marked as reviewed.',
  ),
  sinConexion: txt(
    'Navieras de exportaciones en curso con las que la app no tiene conexión; se siguen a mano. Entre paréntesis, cuántas exportaciones.',
    'Shipping lines of exports in progress that the app has no connection with; they are tracked by hand. In brackets, how many exports.',
  ),
  consultas: txt(
    'Cada consulta a una naviera: exportación, booking, resultado y lo que cambió (antes → después). Por revisar = con cambios sin revisar.',
    'Each check with a shipping line: export, booking, result and what changed (before → after). To review = with unreviewed changes.',
  ),
} satisfies Record<string, Texto>;

// Exportaciones → Financiaciones (Status BLQ e Intercompany Export Chain).
export const AYUDA_FINANCIACIONES = {
  usado: txt(
    'Lo que ocupa el cupo hoy: lo financiado que el comprador todavía no paga. En BLQ cuenta solo lo ya facturado al financiador con su pago inicial. Lo calcula la app.',
    'What uses the credit line today: what was financed and the buyer has not paid yet. In BLQ only what was already invoiced to the financer with its initial payment counts. The app works it out.',
  ),
  cupo: txt(
    'Cupo del financiador (se ajusta en Financiadores y cupos), el porcentaje usado y lo que queda disponible = cupo − usado. En rojo desde el 90 %.',
    'Financer credit line (set in Financers and credit lines), the percentage used and what is left = line − used. In red from 90 %.',
  ),
  incluye: txt(
    'Cupo compartido: cuánto usa cada línea del mismo cupo.',
    'Shared line: how much each line under the same limit uses.',
  ),
  ventaDirecta: txt(
    'Venta directa, sin financiador: lo que el comprador todavía debe de las exportaciones abiertas.',
    'Direct sale, with no financer: what the buyer still owes on open exports.',
  ),
  abiertas: txt(
    'Exportaciones de esta línea que el comprador todavía no ha pagado.',
    'Exports on this line that the buyer has not paid yet.',
  ),
  porFinanciar: txt(
    'Monto de las exportaciones abiertas marcadas "por financiar" (todavía no las financia).',
    'Amount of open exports marked "to be financed" (not financed yet).',
  ),
  porCobrar: txt(
    'Lo que el comprador debe pagar de las exportaciones abiertas: el valor de su factura o, si no la hay, lo financiado.',
    'What the buyer must pay on open exports: its invoice value or, if there is none, the amount financed.',
  ),
  vencido: txt(
    'Lo que el comprador debía pagar antes de hoy y todavía no aparece pagado.',
    'What the buyer had to pay before today and is not shown as paid yet.',
  ),
  mes: txt('Mes de la proyección, desde el mes actual.', 'Projection month, from the current month.'),
  desembolsos: txt(
    'Lo que los financiadores deberían desembolsar ese mes: financiaciones sin desembolso cuya fecha esperada cae en el mes.',
    'What the financers should disburse that month: financings without disbursement whose expected date falls in the month.',
  ),
  pagosCompradores: txt(
    'Lo que los compradores deberían pagar ese mes según la fecha esperada de pago.',
    'What the buyers should pay that month by the expected payment date.',
  ),
  usoAlCierre: txt(
    'Cuánto del cupo estaría ocupado al último día del mes: lo ya financiado más lo que se desembolsa, menos lo que pagan los compradores. Un pago vencido sigue ocupando el cupo.',
    'How much of the line would be used on the last day of the month: what is financed plus what is disbursed, minus what buyers pay. An overdue payment keeps using the line.',
  ),
  historiaHoy: txt(
    'Dinero que el financiador tiene afuera hoy (en la venta directa, lo que se debe).',
    'Money the financer has out today (in direct sale, what is owed).',
  ),
  historiaMaximo: txt(
    'Lo más alto que llegó a estar el uso hasta hoy, con su fecha y el porcentaje del cupo.',
    'The highest the use has been up to today, with its date and the percentage of the line.',
  ),
  historiaProyectado: txt(
    'Lo más alto que llegaría el uso después de hoy con las fechas esperadas. En rojo si pasa el cupo.',
    'The highest the use would reach after today with the expected dates. In red if it goes over the line.',
  ),
  buscar: txt(
    'Busca por código de exportación, factura, referencia del financiador, BL o factura del comprador. Pulsa Enter.',
    'Search by export code, invoice, financer reference, BL or buyer invoice. Press Enter.',
  ),
  financiador: txt(
    'Quién financia la exportación: BLQ, BLQM (lo de Mineros), LC (carta de crédito), BC (banco) o HG (venta directa). Sale de la columna Invoice ID del Status BLQ, como la fórmula del archivo; se cambia en el detalle de la exportación.',
    'Who finances the export: BLQ, BLQM (Mineros), LC (letter of credit), BC (bank) or HG (direct sale). It comes from the Invoice ID column of the Status BLQ, like the file’s formula; it is changed in the export detail.',
  ),
  estado: txt(
    'Lo calcula la app: cerrada si el comprador pagó; venta directa si es HG; por financiar si está marcada así; financiada si tiene desembolso o pago inicial; si no, en proceso con el financiador.',
    'The app works it out: closed if the buyer paid; direct sale if it is HG; to be financed if marked so; financed if it has a disbursement or initial payment; otherwise in process with the financer.',
  ),
  anio: txt(
    'Año del zarpe (ETD) de la exportación en el seguimiento. "Sin dato" = sin ETD.',
    'Year of the export’s departure (ETD) in tracking. "No data" = no ETD.',
  ),
  exportador: txt(
    'Empresa exportadora de la exportación, según el seguimiento.',
    'Exporting company of the export, per tracking.',
  ),
  soloVencidas: txt(
    'Solo las exportaciones cuyo pago esperado ya pasó y el comprador todavía no ha pagado.',
    'Only exports whose expected payment has passed and the buyer has not paid yet.',
  ),
  exportacion: txt(
    'Código de la exportación. Ábrela para trabajar su financiación. "⚠ revisar" = entró del archivo con algo raro (financiador desconocido o una fecha que no es fecha).',
    'Export code. Open it to work on its financing. "⚠ review" = it came from the file with something odd (unknown financer or a date that is not a date).',
  ),
  zarpe: txt('Zarpe (ETD) de la exportación en el seguimiento.', 'Departure (ETD) of the export in tracking.'),
  etaMundra: txt(
    'Llegada estimada a Mundra según el seguimiento. En BLQ de ella sale la fecha de pago al financiador.',
    'Estimated arrival in Mundra per tracking. In BLQ the payment date to the financer comes from it.',
  ),
  financiado: txt(
    'Monto financiado en dólares. Del Status BLQ (hoja DATA, Financed Amount) o, si no está, del Intercompany Export Chain; se edita en la app.',
    'Amount financed in dollars. From the Status BLQ (sheet DATA, Financed Amount) or, if missing, from the Intercompany Export Chain; it is edited in the app.',
  ),
  desembolso: txt(
    'Fecha en que el financiador pagó, del archivo o escrita en la app. Sin ella, la esperada: en BLQ y BLQM el día del zarpe (real o ETD); en las demás, la del archivo o la escrita en la app.',
    'Date the financer paid, from the file or entered in the app. Without it, the expected one: in BLQ and BLQM the departure day (actual or ETD); in the others, the file’s date or the one entered in the app.',
  ),
  pagaAlFinanciador: txt(
    'Empresa que le paga al financiador: la que lo sigue en la cadena de empresas; si no está en la cadena, el comprador final.',
    'Company that pays the financer: the one after it in the company chain; if it is not in the chain, the final buyer.',
  ),
  pagaComprador: txt(
    'Valor de la factura que se le cobra al comprador para pagar la financiación. Del Status BLQ, hoja DATA; se edita en la app.',
    'Value of the invoice charged to the buyer to repay the financing. From the Status BLQ, sheet DATA; it is edited in the app.',
  ),
  fechaPago: txt(
    'Si ya pagó, la fecha del pago. Si no, la esperada: en BLQ, 5 días hábiles antes de la llegada a Mundra (3 en BLQM); en las demás, la del archivo o la escrita en la app. En rojo si ya venció.',
    'If already paid, the payment date. Otherwise the expected one: in BLQ, 5 business days before arrival in Mundra (3 in BLQM); in the others, the file’s date or the one entered in the app. In red if overdue.',
  ),
  factura: txt(
    'Número de la factura al financiador. Sale de la columna Invoice ID del Status BLQ.',
    'Number of the invoice to the financer. It comes from the Invoice ID column of the Status BLQ.',
  ),
  referencia: txt(
    'Referencia de la financiación con el financiador. Del Status BLQ: BLQ/LC ID.',
    'Financing reference with the financer. From the Status BLQ: BLQ/LC ID.',
  ),
  bl: txt(
    'Número del BL de la exportación, del Status BLQ o del Intercompany.',
    'BL number of the export, from the Status BLQ or the Intercompany.',
  ),
  cadena: txt(
    'Cadena de empresas por la que pasa la venta, de la primera al comprador final. Del Intercompany Export Chain, hoja Colombia, columna Intercompany.',
    'Chain of companies the sale goes through, from the first to the final buyer. From the Intercompany Export Chain, sheet Colombia, column Intercompany.',
  ),
  queCambiaExcel: txt(
    'Lo que pasará con esa fila al confirmar: nueva financiación, cambio, choque (alguien la cambió en la app después de bajar el Excel), error o sin cambios.',
    'What will happen to that row on confirming: new financing, change, conflict (someone changed it in the app after the Excel was downloaded), error or no changes.',
  ),
} satisfies Record<string, Texto>;

// Configuración de campos → Financiadores y cupos.
export const AYUDA_FINANCIADORES = {
  eliminar: txt(
    'Solo administradores. Primero se ve qué tiene: sus exportaciones (y cuántas siguen abiertas), sus pagos de Cashflow, sus bancos y quién usa su cupo. Elige a qué financiador pasan sus exportaciones (quedan sin banco y con el tipo de crédito solo si el nuevo lo da) o déjalas sin financiador. Sus bancos se borran. Pide confirmar y queda en la bitácora, desde donde un administrador lo puede deshacer.',
    'Administrators only. First you see what it has: its exports (and how many are still open), its Cashflow payments, its banks and who uses its line. Choose which financer its exports move to (they lose the bank and keep the credit type only if the new one gives it) or leave them without financer. Its banks are deleted. It asks to confirm and stays in the audit log, where an administrator can undo it.',
  ),
  codigo: txt(
    'Código fijo del financiador (BLQ, BLQM, LC, BC, HG). Se crea al cargar el Status BLQ.',
    'Fixed financer code (BLQ, BLQM, LC, BC, HG). It is created when the Status BLQ is loaded.',
  ),
  nombre: txt(
    'Nombre con que se muestra el financiador en la app. Se escribe aquí.',
    'Name the financer is shown with in the app. It is typed here.',
  ),
  cupo: txt(
    'Cupo máximo en dólares que da el financiador. Vacío = por definir. La venta directa no tiene cupo.',
    'Maximum credit line in dollars the financer gives. Empty = to be defined. Direct sale has no line.',
  ),
  comparte: txt(
    'Si esta línea usa el cupo de otro financiador: lo que usa se suma allá y el cupo total es la suma de los dos.',
    'Whether this line uses another financer’s limit: what it uses is added there and the total line is the sum of both.',
  ),
  notas: txt('Notas libres sobre el financiador.', 'Free notes about the financer.'),
} satisfies Record<string, Texto>;

// Exportaciones → Certificados (decision 0067).
export const AYUDA_CERTIFICADOS = {
  ligar: txt(
    'Este certificado de la recolección (por ejemplo, del Generador) no tiene Big Bags en la app y su oro es igual al de estos Big Bags: son los suyos. Ligarlos evita crear otro certificado con los mismos Big Bags. Quita la marca si no son.',
    'This pickup certificate (for example, from the generator) has no Big Bags in the app and its gold equals these Big Bags: they are its own. Linking them avoids creating another certificate with the same Big Bags. Untick it if they are not.',
  ),
  eliminarUno: txt(
    'Borra este certificado (el de origen se lleva su certificado de análisis) y deja sus Big Bags sin él, para volver a crearlo bien. Se puede deshacer desde la Bitácora.',
    'Deletes this certificate (the origin one takes its analysis certificate with it) and leaves its Big Bags without it, to create it again correctly. It can be undone from the Audit log.',
  ),
  paquete: txt(
    'Todo lo de la VUCE de una exportación en un ZIP: los certificados de origen unidos en un PDF ("C. Origen MM100"), los de planta de beneficio en otro, cada certificado suelto (los de análisis en Word) y la carta relación de certificados de análisis con su tabla. Las toneladas son secas y el mineral es oro más plata en gramos. En amarillo, los certificados que se exportan en parte: la carta explica dónde está el resto.',
    'Everything for the VUCE of an export in a ZIP: the origin certificates joined in one PDF ("C. Origen MM100"), the processing plant ones in another, each certificate on its own (the analysis ones in Word) and the analysis certificates relation letter with its table. Tons are dry and mineral is gold plus silver in grams. In yellow, the certificates exported in part: the letter explains where the rest is.',
  ),
  eliminar: txt(
    'Recolección: borra todos sus certificados de origen y de análisis. Exportación: quita los certificados de sus Big Bags; el que queda sin Big Bags se borra y el que sigue en otra exportación (una recolección repartida) se queda con los de la otra. Primero muestra qué se borraría. Se puede deshacer desde la Bitácora.',
    'Pickup: deletes all its origin and analysis certificates. Export: removes the certificates from its Big Bags; one left without Big Bags is deleted and one still in another export (a split pickup) stays with the other’s. It first shows what would be deleted. It can be undone from the Audit log.',
  ),
  consecutivos: txt(
    'Cada título minero tiene su propio consecutivo de certificados de origen, el mismo del Generador de Certificados de Origen. El siguiente es el mayor usado más uno; los boletines también gastan números del título.',
    'Each mining title has its own consecutive number for origin certificates, the same one as the origin certificate generator. The next one is the highest used plus one; bulletins also use the title’s numbers.',
  ),
  series: txt(
    'Los certificados de análisis del laboratorio tienen su propia serie (MM, BV, MV, MS). La app propone el siguiente número de cada una.',
    'The lab’s analysis certificates have their own series (MM, BV, MV, MS). The app suggests the next number of each.',
  ),
  ultimoConsecutivo: txt(
    'Si se usó un número en el Generador que la app todavía no tiene, escríbelo aquí para que la app no lo repita.',
    'If a number was used in the generator that the app does not have yet, type it here so the app does not repeat it.',
  ),
  porFuera: txt(
    'Para los certificados que se hicieron aparte, fuera de la app. Su número queda tomado y la app sigue con el siguiente, en el título y en la serie de análisis. Si escribes los Big Bags, quedan ligados y ya no salen como pendientes. Si no los sabes todavía, escribe la recolección y el oro: al crear los certificados de esa recolección, la app propone ligarlos si el oro es igual.',
    'For certificates made separately, outside the app. Their number is taken and the app moves on to the next one, in the title and in the analysis series. If you type the Big Bags, they are linked and no longer show as pending. If you do not know them yet, type the pickup and the gold: when creating that pickup’s certificates, the app proposes linking them if the gold is the same.',
  ),
  plantas: txt(
    'Razón social, NIT y RUCOM de cada planta de beneficio, para el certificado de origen de planta de beneficio.',
    'Company name, tax ID and RUCOM of each beneficiation plant, for the beneficiation plant origin certificate.',
  ),
  comercializador: txt(
    'La empresa que comercializa el mineral: sale en el certificado de origen de planta de beneficio. Viene del Generador (CONFIG_PLANTA).',
    'The company that trades the mineral: it appears on the beneficiation plant origin certificate. It comes from the generator (CONFIG_PLANTA).',
  ),
  buscar: txt(
    'Número del certificado, recolección (S-606), exportación o Big Bag.',
    'Certificate number, pickup (S-606), export or Big Bag.',
  ),
  cargas: txt(
    'Revisar muestra qué entraría sin guardar nada; Guardar lo deja en la app. Lo que se cambió en la app no se pisa.',
    'Review shows what would come in without saving anything; Save keeps it in the app. What was changed in the app is not overwritten.',
  ),
  facturas: txt(
    'Lee las facturas electrónicas en PDF del expediente de cada exportación (categoría Factura): número, fecha, vencimiento y gramos. Cada factura se liga con sus Big Bags: en Mona Minas por mina, en Colombian Mint por tipo (JIG o FLO) y proveedor; el grupo es el que tiene el mismo oro. Una factura nueva que se sube al expediente se lee sola.',
    'Reads the electronic invoices in PDF in each export file (Invoice category): number, date, due date and grams. Each invoice is linked to its Big Bags: in Mona Minas by mine, in Colombian Mint by type (JIG or FLO) and supplier; the group is the one with the same gold. A new invoice uploaded to the export file is read on its own.',
  ),
  orden: txt(
    'Orden: 1) el Generador de Certificados de Origen (títulos, consecutivos y boletines); 2) la Relación Pago Regalías (lo que ya está ligado por Big Bag); 3) los controles de empaque de las exportaciones que faltan en la relación, varios a la vez.',
    'Order: 1) the origin certificate generator (titles, numbers and bulletins); 2) the royalty payment relation (what is already linked by Big Bag); 3) the packing controls of the exports missing from the relation, several at once.',
  ),
  // Generar (decision 0072).
  descargarOrigen: txt(
    'El certificado de origen y el de planta de beneficio en PDF, sobre el formato oficial de la ANM en blanco (Administración → Documentos). Salen con los datos del título, el comercializador y el comprador que están arriba.',
    'The origin certificate and the processing plant certificate in PDF, on the blank official ANM form (Administration → Documents). They use the title, trader and buyer details shown above.',
  ),
  descargarAnalisis: txt(
    'El certificado de análisis en Word, sobre el formato del laboratorio: el de Mona Minas con los totales; el de Colombian Mint con una fila por Big Bag. Plantillas en Administración → Documentos.',
    'The analysis certificate in Word, on the laboratory form: Mona Minas with the totals; Colombian Mint with one row per Big Bag. Templates in Administration → Documents.',
  ),
  compradorTipo: txt(
    'La casilla del formato: consumidor si el comprador es del exterior, comercializador si es nacional. Sin elegir, la app usa el RUCOM: si el comprador no tiene RUCOM, es consumidor.',
    'The box on the form: consumer if the buyer is abroad, trader if it is local. If not chosen, the app uses the RUCOM: a buyer without RUCOM is a consumer.',
  ),
  crear: txt(
    'Escribe la recolección (S-606). La app agrupa sus Big Bags por título minero y planta: cada grupo lleva un certificado de origen y uno de análisis. Si un título tiene Big Bags de dos plantas, salen A y B. Los números que propone son los siguientes de cada título y de cada serie; puedes cambiarlos. Al crear, los Big Bags quedan ligados a sus certificados.',
    'Type the pickup (S-606). The app groups its Big Bags by mining title and plant: each group gets an origin certificate and an analysis certificate. If a title has Big Bags from two plants, they become A and B. The suggested numbers are the next ones of each title and series; you can change them. When created, the Big Bags are linked to their certificates.',
  ),
  numeroCo: txt(
    'El siguiente consecutivo del título. Si ya usaste ese número en el Generador, cámbialo: la app no deja repetir un número del mismo título.',
    'The next number of the title. If you already used it in the generator, change it: the app does not allow repeating a number of the same title.',
  ),
  numeroAnalisis: txt(
    'El siguiente número de la serie de análisis del título (MM-400, BV-158). Déjalo vacío si el grupo no lleva análisis.',
    'The next number of the title’s analysis series (MM-400, BV-158). Leave it empty if the group has no analysis.',
  ),
  fechaCo: txt(
    'La fecha que imprime el certificado: el primero del mes de molienda de sus Big Bags, como en el Generador.',
    'The date printed on the certificate: the first day of its Big Bags’ grinding month, as in the generator.',
  ),
  fechasAnalisis: txt(
    'Las fechas del certificado de análisis: la recepción va del primer al último empaque de los Big Bags; el ensayo empieza con la recepción y debe terminar después de ella; la emisión es al día siguiente. Se pueden cambiar.',
    'The analysis certificate dates: reception goes from the first to the last packing of the Big Bags; the assay starts with the reception and must end after it; the issue date is the next day. They can be changed.',
  ),
  fechaComercializacion: txt(
    'La fecha de comercialización del certificado de origen. Puede quedar vacía y llenarse después.',
    'The commercialization date of the origin certificate. It can stay empty and be filled later.',
  ),
} satisfies Record<string, Texto>;
